import script from "./TradeAndReceivables.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeAndReceivables.vue?vue&type=script&setup=true&lang=js"

import "./TradeAndReceivables.vue?vue&type=style&index=0&id=f6aa08de&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6aa08de"]])

export default __exports__